import styled from 'styled-components';
import Toggle from '@paradigm/design-system/src/components/Toggle';

interface PostOnlySwitchProps {
  disabled?: boolean;
  isPostOnly: boolean;
  onChange: (value?: boolean) => void;
  className?: string;
}

export default function PostOnlySwitch({
  onChange,
  className,
  disabled = false,
  isPostOnly = false,
}: PostOnlySwitchProps) {
  return (
    <SwitchContainer className={className}>
      <Toggle
        checked={isPostOnly}
        disabled={disabled}
        label="Post Only"
        name="post-only-toggle"
        onChange={() => onChange()}
        ariaLabel="toggle post only"
        data-testid="post-only-switch"
      />
    </SwitchContainer>
  );
}

const SwitchContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 8px;
`;
